"use client";

import React from "react";
import { useSession } from "@/lib/auth-client";

export type User = {
  name: string;
  email: string;
  avatar: string;
};

/**
 * Conditional component that renders different content based on user authentication state
 * @param userContent - Function to render content when user is authenticated
 * @param noUserContent - Content to render when user is not authenticated
 */
export function UserOrNot({
  userContent,
  noUserContent,
}: {
  userContent: (user: User) => React.ReactNode;
  noUserContent: React.ReactNode;
}) {
  const { data: session, isPending } = useSession();
  const sessionUser = session?.user;

  if (isPending) {
    return null;
  }

  // Show noUserContent if user is not authenticated
  if (!sessionUser) {
    return noUserContent;
  }

  // Render user-specific content if authenticated
  return userContent({
    name: sessionUser.name || "User",
    email: sessionUser.email || "",
    avatar: sessionUser.image || "",
  });
}
